import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function carouselCenter() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.blockCarouselCenter');
        if(blocks){
        blocks.forEach(block=>{
            new Splide(block, {
     
              perPage: 3,
              perMove: 1,
              interval: 9500,
              pagination: false,
              arrows: true,
              breakpoints: {
                1100: {
                  perPage : 2,
                  perMove : 1,
                   arrows: true,
                },
                768: {
                  perPage : 1,
                  perMove : 1,
                  pagination : false,
                }
              }
              }).mount();
        });
      }
    })
    
}